import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '../translation';

Vue.use(VueI18n);

export enum Locales {
  CS = 'cs'
}

export default new VueI18n({
  locale: Locales.CS,
  fallbackLocale: Locales.CS,
  pluralizationRules: {
    [Locales.CS]: (choice: number) => {
      // used example from https://kazupon.github.io/vue-i18n/guide/pluralization.html#custom-pluralization
      // 1 den 2 dny 5 dny 10 dní
      if (choice === 0) {
        return 0;
      }

      if (choice === 1) {
        return 1;
      }

      if (choice >= 2 && choice <= 4) {
        return 2;
      }

      return 3;
    },
  },
  messages,
});
